import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  FlightBusinessPersonAudit,
  FlightCrewMemberAudit,
  FlightCrewMemberCateringAudit,
  FlightCrewMemberHotelAudit,
  FlightCrewMemberTransportationAudit,
  FlightPassengerAudit,
  FlightPassengerCateringAudit,
  FlightPassengerHotelAudit,
  FlightPassengerTransportationAudit,
  LegNoteAudit,
  ScheduledAircraftTripAudit,
  ScheduledAircraftTripSkeleton,
  ScheduledEventAudit,
  ScheduledFlightAudit,
  FlightFuelAudit,
  AuditLogLite,
  TripLegItem,
  FlightCrewMemberItem,
  FlightPassengerItem,
  FlightSchedulerItem
} from '../../+models/trip-audit.model';

@Component({
  selector: 'sd-portal-scheduled-trip-audit',
  templateUrl: './scheduled-trip.component.html',
  styleUrls: ['./scheduled-trip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScheduledTripComponent implements OnInit {
  // Inputs
  @Input() tripId: number;
  @Input() scheduledAircraftTripSkeletonLoading: boolean;
  @Input() scheduledAircraftTripSkeletonLoaded: boolean;
  @Input() scheduledAircraftTripSkeleton: ScheduledAircraftTripSkeleton;

  @Input() tripAuditLoading: boolean;
  @Input() tripAuditLoaded: boolean;
  @Input() tripAudits: ScheduledAircraftTripAudit[];

  @Input() tripLogsLoading: boolean;
  @Input() tripLogsLoaded: boolean;
  @Input() tripLogs: AuditLogLite[];
  @Input() tripLogsHasMore: boolean;

  @Input() tripLegsLoading: boolean;
  @Input() tripLegsLoaded: boolean;
  @Input() tripLegs: TripLegItem[];
  @Input() tripLegsHasMore: boolean;

  @Input() legAuditLoading: boolean;
  @Input() legAuditLoaded: boolean;
  @Input() legAudits: ScheduledFlightAudit[];

  @Input() passengerAuditLoading: boolean;
  @Input() passengerAuditLoaded: boolean;
  @Input() passengerAudits: FlightPassengerAudit[];

  @Input() passengerCateringAuditLoading: boolean;
  @Input() passengerCateringAuditLoaded: boolean;
  @Input() passengerCateringAudits: FlightPassengerCateringAudit[];

  @Input() passengerHotelAuditLoading: boolean;
  @Input() passengerHotelAuditLoaded: boolean;
  @Input() passengerHotelAudits: FlightPassengerHotelAudit[];

  @Input() passengerTransportationAuditLoading: boolean;
  @Input() passengerTransportationAuditLoaded: boolean;
  @Input() passengerTransportationAudits: FlightPassengerTransportationAudit[];

  @Input() crewMemberAuditLoading: boolean;
  @Input() crewMemberAuditLoaded: boolean;
  @Input() crewMemberAudits: FlightCrewMemberAudit[];

  @Input() crewMemberCateringAuditLoading: boolean;
  @Input() crewMemberCateringAuditLoaded: boolean;
  @Input() crewMemberCateringAudits: FlightCrewMemberCateringAudit[];

  @Input() crewMemberHotelAuditLoading: boolean;
  @Input() crewMemberHotelAuditLoaded: boolean;
  @Input() crewMemberHotelAudits: FlightCrewMemberHotelAudit[];

  @Input() crewMemberTransportationAuditLoading: boolean;
  @Input() crewMemberTransportationAuditLoaded: boolean;
  @Input() crewMemberTransportationAudits: FlightCrewMemberTransportationAudit[];

  @Input() businessPersonAuditLoading: boolean;
  @Input() businessPersonAuditLoaded: boolean;
  @Input() businessPersonAudits: FlightBusinessPersonAudit[];

  @Input() scheduledEventAuditLoading: boolean;
  @Input() scheduledEventAuditLoaded: boolean;
  @Input() scheduledEventAudits: ScheduledEventAudit[];

  @Input() legNoteAuditLoading: boolean;
  @Input() legNoteAuditLoaded: boolean;
  @Input() legNoteAudits: LegNoteAudit[];

  @Input() flightFuelAuditLoading: boolean;
  @Input() flightFuelAuditLoaded: boolean;
  @Input() flightFuelAudits: FlightFuelAudit[];

  // V2 Inputs for Crew Members
  @Input() flightCrewMembersLoading: boolean;
  @Input() flightCrewMembersLoaded: boolean;
  @Input() flightCrewMembers: FlightCrewMemberItem[];
  @Input() flightCrewMembersHasMore: boolean;

  @Input() crewLogsLoading: boolean;
  @Input() crewLogsLoaded: boolean;
  @Input() crewLogs: AuditLogLite[];
  @Input() crewLogsHasMore: boolean;

  @Input() crewCateringLogsLoading: boolean;
  @Input() crewCateringLogsLoaded: boolean;
  @Input() crewCateringLogs: AuditLogLite[];
  @Input() crewCateringLogsHasMore: boolean;

  @Input() crewHotelLogsLoading: boolean;
  @Input() crewHotelLogsLoaded: boolean;
  @Input() crewHotelLogs: AuditLogLite[];
  @Input() crewHotelLogsHasMore: boolean;

  @Input() crewTransportationLogsLoading: boolean;
  @Input() crewTransportationLogsLoaded: boolean;
  @Input() crewTransportationLogs: AuditLogLite[];
  @Input() crewTransportationLogsHasMore: boolean;

  // V2 Inputs for Passengers
  @Input() flightPassengersLoading: boolean;
  @Input() flightPassengersLoaded: boolean;
  @Input() flightPassengers: FlightPassengerItem[];
  @Input() flightPassengersHasMore: boolean;

  @Input() passengerLogsLoading: boolean;
  @Input() passengerLogsLoaded: boolean;
  @Input() passengerLogs: AuditLogLite[];
  @Input() passengerLogsHasMore: boolean;

  @Input() passengerCateringLogsLoading: boolean;
  @Input() passengerCateringLogsLoaded: boolean;
  @Input() passengerCateringLogs: AuditLogLite[];
  @Input() passengerCateringLogsHasMore: boolean;

  @Input() passengerHotelLogsLoading: boolean;
  @Input() passengerHotelLogsLoaded: boolean;
  @Input() passengerHotelLogs: AuditLogLite[];
  @Input() passengerHotelLogsHasMore: boolean;

  @Input() passengerTransportationLogsLoading: boolean;
  @Input() passengerTransportationLogsLoaded: boolean;
  @Input() passengerTransportationLogs: AuditLogLite[];
  @Input() passengerTransportationLogsHasMore: boolean;

  // V2 Inputs for Fuel Logs
  @Input() legFuelLogsLoading: boolean;
  @Input() legFuelLogsLoaded: boolean;
  @Input() legFuelLogs: AuditLogLite[];
  @Input() legFuelLogsHasMore: boolean;

  // V2 Inputs for Schedulers (Requester / Approver / Planner)
  @Input() flightSchedulersLoading: boolean;
  @Input() flightSchedulersLoaded: boolean;
  @Input() flightSchedulers: FlightSchedulerItem[];
  @Input() flightSchedulersHasMore: boolean;

  @Input() schedulerLogsLoading: boolean;
  @Input() schedulerLogsLoaded: boolean;
  @Input() schedulerLogs: AuditLogLite[];
  @Input() schedulerLogsHasMore: boolean;

  // V2 Inputs for Depart / Arrive Dates (Event Logs)
  @Input() legEventLogsLoading: boolean;
  @Input() legEventLogsLoaded: boolean;
  @Input() legEventLogs: AuditLogLite[];
  @Input() legEventLogsHasMore: boolean;

  // V2 Inputs for Leg Details (Flight Logs)
  @Input() legFlightLogsLoading: boolean;
  @Input() legFlightLogsLoaded: boolean;
  @Input() legFlightLogs: AuditLogLite[];
  @Input() legFlightLogsHasMore: boolean;

  // Outputs
  @Output() onTripNextPage = new EventEmitter<number>();
  @Output() onTripLogsNextPage = new EventEmitter<number>();
  @Output() onTripLegsNextPage = new EventEmitter<number>();

  @Output() onLegOpened = new EventEmitter<number>();
  @Output() onLegNextPage = new EventEmitter<number>();

  @Output() onPassengerOpened = new EventEmitter<number>();
  @Output() onPassengerNextPage = new EventEmitter<number>();

  @Output() onPassengerCateringOpened = new EventEmitter<number>();
  @Output() onPassengerCateringNextPage = new EventEmitter<number>();

  @Output() onPassengerHotelOpened = new EventEmitter<number>();
  @Output() onPassengerHotelNextPage = new EventEmitter<number>();

  @Output() onPassengerTransportationOpened = new EventEmitter<number>();
  @Output() onPassengerTransportationNextPage = new EventEmitter<number>();

  @Output() onCrewMemberOpened = new EventEmitter<number>();
  @Output() onCrewMemberNextPage = new EventEmitter<number>();

  @Output() onCrewMemberCateringOpened = new EventEmitter<number>();
  @Output() onCrewMemberCateringNextPage = new EventEmitter<number>();

  @Output() onCrewMemberHotelOpened = new EventEmitter<number>();
  @Output() onCrewMemberHotelNextPage = new EventEmitter<number>();

  @Output() onCrewMemberTransportationOpened = new EventEmitter<number>();
  @Output() onCrewMemberTransportationNextPage = new EventEmitter<number>();

  @Output() onBusinessPersonOpened = new EventEmitter<number>();
  @Output() onBusinessPersonNextPage = new EventEmitter<number>();

  @Output() onScheduledEventOpened = new EventEmitter<number>();
  @Output() onScheduledEventNextPage = new EventEmitter<number>();

  @Output() onLegNoteOpened = new EventEmitter<number>();
  @Output() onLegNoteNextPage = new EventEmitter<number>();

  @Output() onFlightFuelOpened = new EventEmitter<number>();
  @Output() onFlightFuelNextPage = new EventEmitter<number>();

  // V2 Outputs for Crew Members
  @Output() flightCrewMembersOpened = new EventEmitter<number>();
  @Output() flightCrewMembersNextPage = new EventEmitter<number>();
  @Output() crewLogsOpened = new EventEmitter<number>();
  @Output() crewLogsNextPage = new EventEmitter<number>();
  @Output() crewCateringLogsOpened = new EventEmitter<number>();
  @Output() crewCateringLogsNextPage = new EventEmitter<number>();
  @Output() crewHotelLogsOpened = new EventEmitter<number>();
  @Output() crewHotelLogsNextPage = new EventEmitter<number>();
  @Output() crewTransportationLogsOpened = new EventEmitter<number>();
  @Output() crewTransportationLogsNextPage = new EventEmitter<number>();

  // V2 Outputs for Passengers
  @Output() flightPassengersOpened = new EventEmitter<number>();
  @Output() flightPassengersNextPage = new EventEmitter<number>();
  @Output() passengerLogsOpened = new EventEmitter<number>();
  @Output() passengerLogsNextPage = new EventEmitter<number>();
  @Output() passengerCateringLogsOpened = new EventEmitter<number>();
  @Output() passengerCateringLogsNextPage = new EventEmitter<number>();
  @Output() passengerHotelLogsOpened = new EventEmitter<number>();
  @Output() passengerHotelLogsNextPage = new EventEmitter<number>();
  @Output() passengerTransportationLogsOpened = new EventEmitter<number>();
  @Output() passengerTransportationLogsNextPage = new EventEmitter<number>();

  // V2 Outputs for Fuel Logs
  @Output() legFuelLogsOpened = new EventEmitter<number>();
  @Output() legFuelLogsNextPage = new EventEmitter<number>();

  // V2 Outputs for Schedulers (Requester / Approver / Planner)
  @Output() flightSchedulersOpened = new EventEmitter<number>();
  @Output() flightSchedulersNextPage = new EventEmitter<number>();
  @Output() schedulerLogsOpened = new EventEmitter<number>();
  @Output() schedulerLogsNextPage = new EventEmitter<number>();

  // V2 Outputs for Depart / Arrive Dates + Leg Details
  @Output() legEventLogsOpened = new EventEmitter<number>();
  @Output() legEventLogsNextPage = new EventEmitter<number>();
  @Output() legFlightLogsOpened = new EventEmitter<number>();
  @Output() legFlightLogsNextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}
}
